<template>
  <BaseDialog title="作廢" width="700px" @close="$emit('close')">
    <div v-loading="loading" class="dialog-body flex flex-col gap-[16px]">
      <div class="field">
        <span class="field-label">票匣名稱</span>
        <span>{{ record.name || '-' }}</span>
      </div>
      <div class="field">
        <div class="flex items-center justify-start gap-[8px]">
          <span class="field-label">票匣剩餘張數</span>
          <span class="text-sub text-gray-60">更新時間：{{ formatDateTime(record.updatedAt) }}</span>
        </div>
        <span>{{ record.availableUseTimes }} 張</span>
      </div>
      <p class="text-sub text-gray-60">作廢後將無法復原，確定要作廢？</p>
    </div>
    <template #btnContainer>
      <div class="flex justify-end gap-[8px]">
        <BaseElButton plain @click="$emit('close')">取消</BaseElButton>
        <BaseElButton type="danger" :loading="submitting" @click="onConfirm">作廢</BaseElButton>
      </div>
    </template>
  </BaseDialog>
</template>

<style lang="postcss" scoped>
.dialog-body {
  min-width: 360px;
}
.field {
  @apply flex flex-col gap-[4px];
}
.field-label {
  @apply text-gray-100 font-medium text-sub;
}
</style>

<script>
import { defineComponent, ref, onMounted } from 'vue'
import { useShop } from '@/use/shop'
import { FindTicketBoxRecord, VoidTicketBoxRecord } from '@/api/ticketBoxRecord'
import { formatDate } from '@/utils/date'
import BaseDialog from '@/components/Dialog/BaseDialog.vue'

export default defineComponent({
  name: 'TicketBoxVoidDialog',
  components: { BaseDialog },
  props: {
    recordId: { type: String, required: true },
  },
  emits: ['close', 'confirm'],
  setup (props, { emit }) {
    const { shopId } = useShop()
    const loading = ref(false)
    const submitting = ref(false)
    const record = ref({})

    const fetchRecord = async () => {
      loading.value = true
      const [res, err] = await FindTicketBoxRecord({
        shopId: shopId.value,
        id: props.recordId,
      })
      loading.value = false
      if (err) {
        window.$message.error(err)
        return
      }
      record.value = res
    }

    const onConfirm = async () => {
      if (submitting.value) return
      submitting.value = true
      const [, err] = await VoidTicketBoxRecord({
        shopId: shopId.value,
        id: props.recordId,
      })
      submitting.value = false
      if (err) {
        window.$message.error(err)
        return
      }
      window.$message.success('作廢成功')
      emit('confirm')
    }

    const formatDateTime = (time) => time ? formatDate(time, 'YYYY/MM/DD HH:mm') : '-'

    onMounted(() => {
      fetchRecord()
    })

    return {
      loading,
      submitting,
      record,
      formatDateTime,
      onConfirm,
    }
  },
})
</script>
